import { Signal, useComputed } from "@suse-o11y/signal";

import type { TableColFilter } from "~/components/table/col-filter";
import { fromEntries } from "~/tools/from-entries";
import { ImmutableMap } from "~/tools/immutable-map";
import { map } from "~/tools/map";
import { pipe } from "~/tools/pipe";
import type { Record } from "~/tools/record";
import { toArray } from "~/tools/to-array";
import { Tuple } from "~/tools/tuple";
import { usePermanent } from "~/tools/use-permanent";

import type { OverviewColumnFilter } from "../../common/openapi";

interface UseOverviewFilteringResult {
	filtering: Record<string, OverviewColumnFilter>;
	filters: Signal<ImmutableMap<string, TableColFilter>>;
}

export function useOverviewTableFiltering(): UseOverviewFilteringResult {
	const filters = usePermanent(() => Signal(ImmutableMap.empty<string, TableColFilter>()));

	const filtering = useComputed(
		(monitor) => {
			const entries = filters.read(monitor).entries();

			return pipe(
				toArray(entries),
				map(([columnId, { query }]): OverviewColumnFilter => ({ columnId, search: query })),
				map((entry) => Tuple(entry.columnId, entry)),
				fromEntries(),
			);
		},

		[filters],
	);

	return { filtering, filters };
}
